module.exports = __webpack_public_path__ + "3435bfb2413ab1f86469af6f0c40de08.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review_1.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review_1.jpg
// module chunks = 40